module.exports = __webpack_public_path__ + "img/pagamentos.18daa2a7.svg";